module.exports = __webpack_public_path__ + "static/company-springkraf-start-cd9519e279b8a1f1b29669d75d8c4904.jpg";